import React, { useEffect, useState }             from "react"
import { loadState }                              from "../../sdk/util/loadState";
import shop                                       from "shop/shop"
import { Button, Icon, Label, Table }             from "semantic-ui-react";
import { Link }                                   from "react-router-dom";
import { CreateCustomerModal, EditCustomerModal } from "./CustomerDetailPage";

// DONT SHOW THIS USER TO ADENT / ORTHO
const banId = "5043"

export default function PowerUsersTable( props ) {
  const [representatives, setRepresentatives] = useState( false )
  const [iteration, setIteration] = useState( false )
  const handuser_id = shop.session.handId
  useEffect( loadState( setRepresentatives, `/shop/rest/users/data?start=0&count=100&filter=${encodeURIComponent( JSON.stringify( { handuser_id } ) )}` ), [handuser_id, iteration] )
  console.log( { representatives } )
  
  const users = representatives && representatives.filter( e => e.id != banId)
  if ( !representatives ) return null
  return <div>
    <TableAccounts onChange={() => {
      setIteration( Math.random() )
    }} users={users} {...props}/>
  </div>
}

const TableAccounts = ( { to, onBudget, onAccounts, onSelect, onChange, hideColRep = false, hideColContact = false, users = [], } ) => {
  
  const [showNewAccountModal, setShowNewAccountModal] = useState( false )
  const [showEditAccountModal, setShowEditAccountModal] = useState( false )
  const customer = {}
  const customerId = 2
  
  return (
    <div>
      {showEditAccountModal && <EditCustomerModal
        customerId={customerId}
        customer={customer}
        user={showEditAccountModal}
        onClose={() => {
          setShowEditAccountModal( false )
        }}
        open={showEditAccountModal}>
      </EditCustomerModal>}
      
      
      <CreateCustomerModal
        customerId={customerId}
        customer={customer}
        onClose={() => {
          setShowNewAccountModal( false )
          onChange()
        }}
        open={showNewAccountModal}
      />
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>#</Table.HeaderCell>
            <Table.HeaderCell>{translate( "Name" )}</Table.HeaderCell>
            {!hideColRep && <Table.HeaderCell>{translate( "Vertreter" )}</Table.HeaderCell>}
            {!hideColContact && <Table.HeaderCell>{translate( "Kontakt" )}</Table.HeaderCell>}
            
            {/*<Table.HeaderCell width={1} className={"lh-copy"}>*/}
            {/*  <div className="f7 black-70">{translate( "Rechte" )}</div>*/}
            {/*  <div className={"f6"}>{translate( "Admin" )}</div>*/}
            {/*</Table.HeaderCell>*/}
            
            <Table.HeaderCell width={1} className={"lh-title"}>
              <div className="f7 black-70">{translate( "Rechte" )}</div>
              <div className={"f6"}>{translate( "Benutzer" )}</div>
            </Table.HeaderCell>
            
            <Table.HeaderCell width={1} className={"lh-title"}>
              <div className="f7 black-70">{translate( "Rechte" )}</div>
              <div className={"f6"}>{translate( "Budget" )}</div>
            </Table.HeaderCell>
            
            <Table.HeaderCell width={1} className={"lh-title"}>
              <div className="f7 black-70">{translate( "Rechte" )}</div>
              <div className={"f6"}>{translate( "Besteller" )}</div>
            </Table.HeaderCell>
            
            <Table.HeaderCell width={1} className={"lh-title"}>
              <div className="f7 black-70">{translate( "Rechte" )}</div>
              <div className={"f6"}>{translate( "Sortimente" )}</div>
            </Table.HeaderCell>
            
            <Table.HeaderCell>&nbsp;</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        
        <Table.Body>
          
          {users.length === 0 && <Table.Row>
            <Table.Cell colSpan={8}>Legen Sie den ersten Benutzer an</Table.Cell>
          </Table.Row>}
          
          {users && users.map( user => {
            return <Table.Row key={user.id}>
              <Table.Cell>{user.id}</Table.Cell>
              <Table.Cell>{user.name}</Table.Cell>
              {!hideColRep && <Table.Cell>{user.customer_id}</Table.Cell>}
              {!hideColContact && <Table.Cell>{user.contact_id}</Table.Cell>}
              {/*<Table.Cell>{user.roles.includes( "Admin" ) ? <Label icon={"check"} name={"check"} color={"green"}/> : <Label icon={"circle"}/>} </Table.Cell>*/}
              <Table.Cell>{user.roles.includes( "usermanager" ) ? <Label icon={"check"} name={"check"} color={"green"}/> : <Label icon={"circle"}/>} </Table.Cell>
              <Table.Cell>{user.roles.includes( "costmanager" ) ? <Label icon={"check"} name={"check"} color={"green"}/> : <Label icon={"circle"}/>} </Table.Cell>
              <Table.Cell>{user.roles.includes( "besteller" ) ? <Label icon={"check"} name={"check"} color={"green"}/> : <Label icon={"circle"}/>} </Table.Cell>
              <Table.Cell>{user.roles.includes( "datenmanager" ) ? <Label icon={"check"} name={"check"} color={"green"}/> : <Label icon={"circle"}/>} </Table.Cell>
              
              <Table.Cell>
                <div className="tr"><Button
                  size="tiny"
                  onClick={() => {
                    setShowEditAccountModal( user )
                  }}
                  basic>{translate( "bearbeiten" )}</Button></div>
              </Table.Cell>
            </Table.Row>
          } )}
          
          <Table.Row>
            <Table.Cell colSpan={8}>
              <div className="tr">
                <Button onClick={() => {
                  setShowNewAccountModal( true )
                }} primary>{translate( "Konto hinzufügen" )}</Button>
              </div>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  
  )
}


// WEBPACK FOOTER //
// ./src/components/Budget/PowerUsersTable.js